import React, { useState, useContext } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ValidationContainer } from './style.js';
import { AppStoreContext } from '../../context/appStoreContext.js';

const PhoneNumberValidation = ({ onchange, setValid }) => {
  const [countryCode, setCountryCode] = useState(null);
  const { setCountryList, countryList } = useContext(AppStoreContext);

  const handleChange = (value, data) => {
    onchange(value);
  };

  return (
    <ValidationContainer>
      <PhoneInput
        isValid={(value, country, countries) => {
          countryList.length === 0 && setCountryList(countries);
          return true;
        }}
        onChange={handleChange}
        country={countryCode || 'us'}
        enableSearch={true}
        searchPlaceholder={'Search'}
      />
    </ValidationContainer>
  );
};

export default PhoneNumberValidation;
